export default (node) => {
  /**
   * Data + elements
   */

  /**
   * Functions
   */
  const showCourseDetails = () => {};

  /**
   * Init
   */
  const init = () => {
    // check if the courseDetails is set in local storage
    const courseDetails = localStorage.getItem('courseDetails');
    // if the courseDetails is set in local storage, enable the section course details in the main-order page
    if (courseDetails) {
      const allCourseDetails = document.querySelector(
        '[data-section-course-details]'
      );
      if (allCourseDetails) {
        allCourseDetails.classList.remove('hidden');
        // show the curs details
        const courseDetailsSection = allCourseDetails.querySelector(
          `[data-course-id="${courseDetails}"]`
        );
        if (courseDetailsSection) {
          courseDetailsSection.classList.remove('hidden');
        }

        const backButton = node.querySelector('[data-back-button]');
        backButton.href = backButton.getAttribute('data-back-button');
        const backButtonText = node.querySelector('[data-back-button-text]');
        backButton.querySelector('[data-button-text]').textContent =
          backButtonText.getAttribute('data-back-button-text');
      }
    } else {
      const allOrderDetails = document.querySelectorAll(
        '[data-section-order-details]'
      );
      allOrderDetails.forEach((orderDetails) => {
        orderDetails.classList.remove('hidden');
      });
    }
    localStorage.removeItem('courseDetails');
  };

  init();
};
